import { getAndSanitize } from "../../shared/utils/sanitization";

export const getTokenData = (): { userId: string } | null => {
  try {
    const token = getAndSanitize('token');
    if (!token) return null;
    
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.userId) return null;
    
    return { userId: String(payload.userId) };
  } catch (error) {
    console.error('[Auth] Token parse error:', error);
    return null;
  }
};

export const formatMenuLabel = (value: any): string => {
  if (value === null || value === undefined) return 'None';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return 'Invalid Value';
    }
  }
  return String(value);
};

export const safeToString = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};